import { Link } from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";
import BazaarImage from "@/theme/components/image";
import type { Project } from "@/types";

const ProjectCover = ({ project }: { project: Project }): JSX.Element => {
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { baseUrl, siteUrl, projectLinkTarget, lazyloadImages } = queryFilter;
  const { logoUrl } = useAppSelector((state) => state.site.site);
  const { permalink, imageUrl, name } = project;

  const coverImg = imageUrl || logoUrl;

  return (
    <Link
      h="250px"
      w="100%"
      key={permalink}
      display="block"
      overflow="hidden"
      textAlign="center"
      rel="noopener noreferrer"
      target={projectLinkTarget}
      className="ehq-projectCoverImg"
      href={`${baseUrl || siteUrl}/${permalink}`}
    >
      <BazaarImage
        src={coverImg}
        htmlAttributes={{ alt: name }}
        imageLazyLoad={lazyloadImages}
        imgixParams={{ fit: "clip", h: 250, w: 462 }}
      />
    </Link>
  );
};

export default ProjectCover;
